/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'
import imperative_recipeImg from 'assets/images/imperative-recipe.jpeg'
import declarative_menuImg from 'assets/images/declarative-menu.jpeg'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Императивный и декларативный код</h2>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Императивный код</h3>
      <p className={styles.description}>
        Описывает процесс вычисления в виде заданной последовательности инструкций, изменяющих состояние программы.
        Описание того, как что-то выполянется.
      </p>
      <p className={styles.description}>
        Императивный стиль программирования это такой, который дает машине набор детальных инструкций для выполнения
        задачи. Например цикл <code className={styles.code}>for</code>, который предоставляет точные указания для
        итерации по индексам массива.
      </p>
      <p className={styles.description}>
        Можно провести аналогию с рецептом приготовления блюда. Рецепт это набор пошаговых инструкций для получения
        желаемого результата.
      </p>
      <img className={styles.img} src={imperative_recipeImg} alt="imperative-recipe" />
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - Декларативный код</h3>
      <p className={styles.description}>
        Описывает то, что мы хотим получить в результате, а не как это сделать. Порядок выполнения и способ достижения
        не важен.{' '}
      </p>
      <p className={styles.description}>
        Когда мы пишем HTML-код, то декларативно, при помощи тегов и атрибутов, описываем что хотим получить в
        результате. Браузер читает этот код и сам выполняет все необходимые операции по созданию HTML-элементов и
        помещению их на страницу.
      </p>
      <p className={styles.description}>
        Можно провести аналогию с меню ресторана. Это декларативный набор возможных к заказу блюд, детали приготовления
        и подачи которых скрыты.
      </p>
      <img className={styles.img} src={declarative_menuImg} alt="declarative-menu" />
      <p className={styles.description}>
        Декларативное описание задачи более наглядно и легче формулируется. Мы говорим что хотим сделать, вызвав метод
        или функцию. Ее реализация скорее всего использует императивный код, но он скрыт внутри и не усложняет понимание
        основного кода.
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.3 - Императивный vs декларативный</h3>
      <p className={styles.description}>
        Рассмотрим разницу подходов на примере базовой операции фильтрации коллекции. Напишем код перебора и фильтрации
        массива чисел по какому-то критерию.
      </p>
      <CopyBlock
        text={`// Императивный подход
const numbers = [1, 2, 3, 4, 5];
const filteredNumbers = [];

for (let i = 0; i < numbers.length; i += 1) {
  if (numbers[i] > 3) {
    filteredNumbers.push(numbers[i]);
  }
}

console.log(filteredNumbers); // [4, 5]`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        <code className={styles.code}>Array.prototype.filter()</code> это метод массива который скрывает в себе логику
        перебора коллекции и вызывает callback-функцию которую мы ему передаем для каждого элемента, возвращая массив
        элементов подошедших под критерий.
      </p>
      <CopyBlock
        text={`// Декларативный подход
const numbers = [1, 2, 3, 4, 5];
const filteredNumbers = numbers.filter(value => {
  return value > 3;
});

console.log(filteredNumbers); // [4, 5]`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
  </section>
))
